import makeTable from "./makeTable";

export enum ColumnId {
	FullName = "fullName",
	Role = "role",
	Alias = "alias",
	Companies = "companies",
	Access = "access",
}

export const translationTablePath = "dispatchersSelectTab.";

const dispatchersSelectTab = makeTable({
	allIds: [
		ColumnId.FullName,
		ColumnId.Role,
		ColumnId.Alias,
		ColumnId.Companies,
		ColumnId.Access,
	],
	i18tPath: (id) => `${translationTablePath}${id}`,
	defaultIds: [
		ColumnId.FullName,
		ColumnId.Role,
		ColumnId.Alias,
		ColumnId.Companies,
		ColumnId.Access,
	],
	initialSortMethod: {
		column: ColumnId.FullName,
		type: "asc",
	},
	initialWidths: {
		[ColumnId.FullName]: 250,
		[ColumnId.Role]: 250,
		[ColumnId.Alias]: 250,
		[ColumnId.Companies]: 250,
		[ColumnId.Access]: 250,
	},
	initialResizable: {
		[ColumnId.FullName]: true,
		[ColumnId.Role]: true,
		[ColumnId.Alias]: true,
		[ColumnId.Companies]: true,
		[ColumnId.Access]: true,
	},
	initialSortable: {
		[ColumnId.FullName]: true,
		[ColumnId.Role]: true,
		[ColumnId.Alias]: true,
		[ColumnId.Companies]: true,
		[ColumnId.Access]: true,
	},
});

export default dispatchersSelectTab;
